import { apiPost } from '../api'

export const save_targets = data => {
  return apiPost({
    endpoint: 'programs/save_target',
    data: data
  })
}
